<script>
  import { loadImage } from "iso-canvas";
  import SpinnerIcon from "@local/assets/icons/spinner-lg.svg";
  import { api } from "#src/api";
  import { settingTriopsUrl as triopsUrl } from "#src/stores/ui.js";

  export let doc;

  let thumbnailKey = crypto.randomUUID();

  async function thumbnailSrc() {
    const thumbnail = doc.data.thumbnail;
    if (thumbnail) {
      if (thumbnail.type === "image") {
        const { data, error } = await api.storage
          .from(thumbnail.bucket)
          .createSignedUrl(thumbnail.path, 60 * 60);

        if (error) return null;
        return data.signedUrl;
      } else if (thumbnail.type === "icon") {
        return `/images/${thumbnail.path}`;
      } else if (thumbnail.type === "url") {
        return thumbnail.url;
      } else {
        const path = encodeURIComponent(thumbnail.path);
        const src = `${$triopsUrl}/iiif/2/${thumbnail.bucket}/${path}/full/540,/0/default.jpg`;
        try {
          await loadImage(src);
          return src;
        } catch (e) {
          return null;
        }
      }
    }
  }
</script>

<div class="relative w-full h-full">
  <div class="w-full h-full flex items-center justify-center bg-white" style="padding:4px;">
    {#if doc.data.thumbnail}
      {#key thumbnailKey}
        {#await thumbnailSrc() then src}
          {#if src}
            <img class="w-full h-full object-cover text-xs" {src} alt={doc.name} />
          {/if}
        {/await}
      {/key}
    {:else}
      <div class="w-full h-full flex flex-col justify-center items-center">
        <div class="animate-spin">
          <SpinnerIcon />
        </div>
      </div>
    {/if}
  </div>
</div>
